import { Link } from 'react-router-dom'
import './Footer.css'

function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="footer">
      <div className="footer-grid-overlay" />
      <div className="footer-content">
        <div className="footer-top">
          <Link to="/" className="footer-logo">Claverton 42</Link>
          
          <div className="footer-links">
            <div className="footer-links-column">
              <Link to="/services">Services</Link>
              <Link to="/news">News</Link>
              <Link to="/about">About</Link>
            </div>
            <div className="footer-links-column">
              <Link to="/careers">Careers</Link>
              <Link to="/contact">Contact</Link>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-copyright">
            ©{currentYear} Claverton 42. All rights reserved.
          </div>
          <a 
            href="https://thecisonetwork.com" 
            target="_blank" 
            rel="noopener noreferrer"
            className="footer-ciso-link"
          >
            Looking for a fractional CISO?
          </a>
        </div>
      </div>
    </footer>
  )
}

export default Footer
